import React from "react";

import { GenericExternalLink } from "@components/generic-external-link";
import { NorthbeamUtmPlatform } from "@features/utm-guide";

import { ConstructDestinationUrl } from "../construct-destination-url";

export const YahooDSP = () => (
  <div className="flex flex-col gap-3">
    <p className="mb-0">
      You will need to add UTM parameters to all <b>destination URLs</b> for new
      and existing ads. For more information, you can look at <b>Yahoo DSP</b>
      &apos;s{" "}
      <GenericExternalLink href="https://developer.yahoo.com/dsp/docs/macros/macros.html">
        documentation
      </GenericExternalLink>
    </p>
    <ConstructDestinationUrl platform={NorthbeamUtmPlatform.YAHOO_DSP} />
    <p className="mb-0">
      Use the copied URL when creating an ad with <b>Yahoo DSP</b>
    </p>
  </div>
);
